import { render, staticRenderFns } from "./Leftcheck.vue?vue&type=template&id=770fa6dc"
import script from "./Leftcheck.vue?vue&type=script&lang=js"
export * from "./Leftcheck.vue?vue&type=script&lang=js"
import style0 from "./Leftcheck.vue?vue&type=style&index=0&id=770fa6dc&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports